// Support pre-setting tenants and other options for CNAME'd hosts
// NOTE:
// Eventually, should make this database driven or perhaps CF Worker  with KV suppor5
// so that we can support whitelabling the software e.g. for GLeadsPro
//
// BC-3025: This map used to live in `admin-app/src/pages/login/hostOverrideOpts.js`
// and was therefore FRONTEND-ONLY. The platform login state machine decides the
// choose-tenant step SERVER-side (`backend/src/services/login/utils/nextFlowHelper.js`),
// so a frontend-only override could never be honored there -- which is exactly why
// `disableTenantChoice` + `defaultTenantId` were silently ignored on
// admin.precina.com / app.johnoberg.com.
//
// It now lives in `shared/` so there is exactly ONE definition read by BOTH the
// frontend (bound to `window.location.hostname`, see
// admin-app/src/pages/login/hostOverrideOpts.js) and the backend (bound to the
// SERVER-OBSERVED request Origin/Referer, see
// backend/src/services/login/utils/resolveLoginHostOverrideOpts.js).
//
// SECURITY NOTE: these flags are a UI-skip HINT, never an authorization grant.
// The backend auto-select validates the declared tenant against the user's OWN
// already-computed TenantUser links before honoring it. A host naming a tenant
// the user has no link to falls back to the chooser -- it must never admit.
export const hostOverrides = {
	// 'retainers.viribuzmedia.com': {
	// 	forceTenantId: 'viribuz',
	// 	disablePhoneChallengeAsDefaultOnMobile: true,
	// 	disablePhoneChallenge: true,
	// 	disablePinChallenge: true,
	// 	disableTenantChoice: true,
	// },
	'app.nextlevelvalet.io': {
		forceTenantId: 'nlvp',
	},
	'launch.gleadspro.io': {
		forceTenantId: 'glp',

		defaultChallenge: 'phone',
		// disablePhoneChallengeAsDefaultOnMobile: true,
		// disablePhoneChallenge: true,
		disablePinChallenge: true,
		disableTenantChoice: true,
	},
	localhost: {
		// defaultTenantId: 'nlvp', // just for testing
		// forceTenantId: 'viribuz',
		// disablePhoneChallengeAsDefaultOnMobile: true,
		// disablePhoneChallenge: true,
		// disablePinChallenge: true,
		// disableTenantChoice: true,
	},
	'app.vayavalet.io': {
		defaultTenantId: 'nlvp',
	},
	'admin.precina.com': {
		defaultTenantId: 'precina',
		forceTenantId: 'precina',
		defaultChallenge: 'phone',
		disablePinChallenge: true,
		disableTenantChoice: true,
		// First added a bundle ID for admin so we could use
		// the same "loading" animations as the patient app in FullPageSpinner
		bundleAppId: 'com.precina.admin',
	},
	'app.pnk.ai': {
		defaultTenantId: 'pink',

		defaultChallenge: 'phone',
		// disablePhoneChallengeAsDefaultOnMobile: true,
		// disablePhoneChallenge: true,
		disablePinChallenge: true,
		disableTenantChoice: true,
	},

	'app.josiahbryan.ai': {
		defaultTenantId: 'viewport', // TODO: [TBD] Better way to configure this??

		defaultChallenge: 'email',
		disablePhoneChallengeAsDefaultOnMobile: true,
		// disablePhoneChallenge: true,
		disablePinChallenge: true,
		// disableTenantChoice: true,
	},
	'notesby.ai': {
		defaultTenantId: 'notesbyai',
		defaultChallenge: 'phone',
		disablePinChallenge: true,
		disableTenantChoice: true,
	},
	'app.meetatthemirror.com': {
		defaultTenantId: 'matm',
		defaultChallenge: 'phone',
		disablePinChallenge: true,
		disableTenantChoice: true,
		bundleAppId: 'com.meetatthemirror',
	},
	'com.precina.app': {
		defaultTenantId: 'precina',
		defaultChallenge: 'phone',
		disablePinChallenge: true,
		disableTenantChoice: true,
		bundleAppId: 'com.precina.app',
	},
	'app.johnoberg.com': {
		defaultTenantId: 'business-coach',
		defaultChallenge: 'phone',
		disablePinChallenge: true,
		disableTenantChoice: true,
		bundleAppId: 'com.johnoberg.app',
	},
	// Avatar Sharing Christ / "Room to Ask". bundleAppId resolves to the
	// com.asc BundleAppConfig (getBundleAppId.js), which sets
	// gpsPermissionRequest.manualInit:true so the platform location prompt
	// never fires for this confidential faith experience. The native app
	// already passes ?bundleAppId=com.asc; this entry covers the web host.
	'app.avatarsharingchrist.com': {
		defaultTenantId: 'asc',
		defaultChallenge: 'phone',
		disablePinChallenge: true,
		disableTenantChoice: true,
		bundleAppId: 'com.asc',
	},
	// SalesForward / "SalesUpLevel". The custom domain + AppInstallation
	// (frontendRootOverride https://app.salesuplevel.com) were set up, but this
	// host-override entry was missing — so the bare domain fell through to the
	// DEFAULT (Vaya) bundle: getBundleAppId() -> DEFAULT_APP_CONFIG, and the
	// unauthenticated root redirected to the generic Vaya /login (valet/driver
	// role chooser, phone challenge, tenant=vaya). That funneled testers into
	// the Vaya login, which then emailed Vaya-branded magic links pointing at
	// app.vayavalet.io with tenant=vaya (OSFS / "Christina" tester failure).
	//
	// SalesForward signs users up through the quiz email gate (email only — no
	// phone is ever collected), so force the salesfwd tenant + email challenge
	// and disable phone/PIN/tenant-choice. bundleAppId 'com.salesforward'
	// resolves to the BundleAppConfig homeUri (/a/salesuplevel) so the root
	// lands on the branded SalesForward app + its own email-only login instead
	// of the platform login.
	'app.salesuplevel.com': {
		defaultTenantId: 'salesfwd',
		forceTenantId: 'salesfwd',
		defaultChallenge: 'email',
		disablePhoneChallenge: true,
		disablePhoneChallengeAsDefaultOnMobile: true,
		disablePinChallenge: true,
		disableTenantChoice: true,
		bundleAppId: 'com.salesforward',
	},
};

/**
 * Normalize anything host-ish (a bare hostname, a `Host` header with a port, a
 * full Origin/Referer URL) down to the bare lowercase hostname used as the key
 * of `hostOverrides`.
 *
 * Deliberately hand-rolled rather than `new URL()` because the values we get
 * are not always parseable URLs -- `otpHost` is frequently a bare hostname, and
 * `new URL('admin.precina.com')` throws.
 *
 * @param {string | undefined | null} value
 * @returns {string} bare lowercase hostname, or '' if nothing usable
 */
export function hostnameFromUrlish(value) {
	if (!value) {
		return '';
	}

	let host = `${value}`.trim();

	// Strip scheme (http://, https://, capacitor://, ...)
	host = host.replace(/^[a-z][a-z0-9+.-]*:\/\//i, '');

	// Strip any userinfo (user:pass@host)
	host = host.replace(/^[^/@]*@/, '');

	// Strip path / query / hash
	[host] = host.split('/');
	[host] = host.split('?');
	[host] = host.split('#');

	// Strip the port. IPv6 literals arrive bracketed ([::1]:3000) and are never
	// a host we key on, so leave them alone rather than mangling on the colons.
	if (!host.startsWith('[')) {
		[host] = host.split(':');
	}

	return host.toLowerCase();
}

/**
 * Resolve the host-override options for a given host.
 *
 * @param {string | undefined | null} hostish bare hostname, Host header, or full URL
 * @returns {object} the override opts, or `{}` when the host is not overridden
 */
export function resolveHostOverrideOpts(hostish) {
	const hostname = hostnameFromUrlish(hostish);
	if (!hostname) {
		return {};
	}
	return hostOverrides[hostname] || {};
}

/**
 * True if the given host has an entry in the override table at all (even an
 * empty one, e.g. `localhost`). Used by the backend to decide whether a
 * candidate host (server-observed header vs client-asserted `otpHost`) is
 * worth using before falling through to the next candidate.
 *
 * @param {string | undefined | null} hostish
 * @returns {boolean}
 */
export function hasHostOverrideEntry(hostish) {
	const hostname = hostnameFromUrlish(hostish);
	return (
		!!hostname && Object.prototype.hasOwnProperty.call(hostOverrides, hostname)
	);
}
